<template lang="pug">
	section#duvida
		.wrapper
			h1 AINDA ESTÁ COM DÚVIDA?
			span BAIXE AGORA UM PDF COMPLETO COM TODAS AS INFORMAÇÕES PARA SE INSCREVER NO PROUNI DE FORMA RÁPIDA E PRÁTICA.
			button(@click="$emit('next')")
				span BAIXE AGORA!
</template>

<script>
export default {
	name: "section-duvida"
}
</script>

<style lang="stylus" scoped src="./Duvida.styl"></style>
